module.exports = __webpack_public_path__ + "img/list_8.8a7a6e84.jpg";